import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  BarChart2,
  Settings,
  Wrench,
  Calendar
} from 'lucide-react';
import { cn } from '@tonic/shared';

const subNavigation = [
  {
    name: 'Overview',
    href: '/admin/re-commerce/rental',
    icon: LayoutDashboard
  },
  {
    name: 'Items',
    href: '/admin/re-commerce/rental/items',
    icon: Package
  },
  {
    name: 'Orders',
    href: '/admin/re-commerce/rental/orders',
    icon: ShoppingCart
  },
  {
    name: 'Program',
    href: '/admin/re-commerce/rental/program',
    icon: Calendar
  },
  {
    name: 'Maintenance',
    href: '/admin/re-commerce/rental/maintenance',
    icon: Wrench
  },
  {
    name: 'Analytics',
    href: '/admin/re-commerce/rental/analytics',
    icon: BarChart2
  },
  {
    name: 'Settings',
    href: '/admin/re-commerce/rental/settings',
    icon: Settings
  }
];

export function RentalLayout() {
  const location = useLocation();

  return (
    <div className="h-full">
      <div className="border-b border-neutral-200 bg-white">
        <div className="px-4 py-2">
          <h1 className="text-2xl font-semibold text-neutral-900">Rental</h1>
          <p className="text-sm text-neutral-500">
            Manage your rental operations, inventory, and customer bookings
          </p>
        </div>
        <nav className="flex space-x-4 px-4">
          {subNavigation.map((item) => {
            const isActive = location.pathname.startsWith(item.href);
            const isExact = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={cn(
                  'flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 -mb-[2px]',
                  'transition-colors duration-200',
                  (isActive || (item.href === '/admin/re-commerce/rental' && isExact))
                    ? 'border-primary text-primary'
                    : 'border-transparent text-neutral-500 hover:text-neutral-900 hover:border-neutral-300'
                )}
              >
                <item.icon className="h-4 w-4" />
                {item.name}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="p-4">
        <Outlet />
      </div>
    </div>
  );
} 
